'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HtmlParser;

var _processNodes = require('./processNodes');

var _processNodes2 = _interopRequireDefault(_processNodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (DOMParser) {
  var DOMParser_proto = DOMParser.prototype,
      real_parseFromString = DOMParser_proto.parseFromString;
  // Firefox/Opera/IE throw errors on unsupported types
  try {
    // WebKit returns null on unsupported types
    if (new DOMParser().parseFromString('', 'text/html')) {
      // text/html parsing is natively supported
      return;
    }
  } catch (ex) {
    // no-op
  }

  DOMParser_proto.parseFromString = function (markup, type) {
    if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
      var doc = document.implementation.createHTMLDocument('');
      if (markup.toLowerCase().indexOf('<!doctype') > -1) {
        doc.documentElement.innerHTML = markup;
      } else {
        doc.body.innerHTML = markup;
      }
      return doc;
    } else {
      return real_parseFromString.apply(this, [markup, type]);
    }
  };
})(DOMParser);

/**
 * @typedef {Object} HtmlParserOptions
 * @property {((node: Node, index: number) => React.ReactNode)=} transform
 * @property {((nodes: NodeList) => (NodeList | Node[]))=} preprocessNodes
 */

/**
 * Parses a HTML string and returns a list of React components generated from it
 *
 * @param {String} html The HTML to convert into React component
 * @param {HtmlParserOptions} options Options to pass
 * @returns {Array} List of top level React elements
 */
function HtmlParser(html) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var transform = options.transform,
      _options$preprocessNo = options.preprocessNodes,
      preprocessNodes = _options$preprocessNo === undefined ?
  /**
   * @param {NodeList} nodes
   */
  function (nodes) {
    return nodes;
  } : _options$preprocessNo;


  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var nodes = doc.body.childNodes;

  return (0, _processNodes2.default)(preprocessNodes(nodes), transform);
}